import { jsx as _jsx } from "react/jsx-runtime";
import { ICONS } from '@app/styles';
import { Grid } from '@nu-art/thunderstorm-frontend';
export const PPIndicatorStatus = {
    pass: 'pass',
    fail: 'fail',
    dataNeeded: 'data-needed',
};
const PPDescription_Base = (p) => {
    const { children, ...rest } = p;
    return _jsx(Grid, { ...rest, children: children });
};
const PPDescription_Row = (p) => _jsx(Grid, { className: 'description-row', onClick: p.onClick, children: p.children });
const PPDescription_RowIndicator = (p) => {
    switch (p.status) {
        case PPIndicatorStatus.dataNeeded:
            return _jsx(ICONS.advisor_v5_transitionInsufficient.component, { className: 'description-row__indicator-icon data-needed' });
        case PPIndicatorStatus.pass:
            return _jsx(ICONS.v.component, { className: 'description-row__indicator-icon pass' });
        case PPIndicatorStatus.fail:
            return _jsx(ICONS.x.component, { className: 'description-row__indicator-icon fail' });
        default:
            return _jsx("div", { className: 'description-row__indicator' });
    }
};
const PPDescription_Title = (p) => _jsx("div", { className: 'description-row__title', children: p.children });
const PPDescription_TitleValue = (p) => p.show
    ? _jsx("div", { className: 'description-row__title-value', children: p.value ?? '-' })
    : undefined;
const PPDescription_TreeLineConnector = () => _jsx("div", { className: 'tree-line-connector' });
const PPDescription_Value = (p) => _jsx("div", { className: 'description-row__value', children: p.children });
export const PPDescription = Object.assign(PPDescription_Base, {
    Row: PPDescription_Row,
    Indicator: PPDescription_RowIndicator,
    Title: PPDescription_Title,
    TitleValue: PPDescription_TitleValue,
    TreeLineConnector: PPDescription_TreeLineConnector,
    Value: PPDescription_Value,
});
//# sourceMappingURL=Component_PrettyPrint_Description.js.map